import React from "react";
import {
  Cell,
  Pie,
  PieChart,
  PieLabelRenderProps,
  ResponsiveContainer,
} from "recharts";

// #endregion
const RADIAN = Math.PI / 180;
const COLORS = ["#375a9e", "#0b8f4e","#a88700" ,"#616161"];  

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {
  if (cx == null || cy == null || innerRadius == null || outerRadius == null) {
    return null;
  }
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const ncx = Number(cx);
  const x = ncx + radius * Math.cos(-(midAngle ?? 0) * RADIAN);
  const ncy = Number(cy);
  const y = ncy + radius * Math.sin(-(midAngle ?? 0) * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > ncx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${((percent ?? 1) * 100).toFixed(0)}%`}
    </text>
  );
};

const OrderDistributionPieChart = React.memo(
  ({ isAnimationActive = true, data }) => {
    return (
      <div className="card rounded-4">
        <div className="card-body">
          <h6 className="mb-3">توزيع حالة الطلب</h6>
          <PieChart
            style={{
              width: "100%",
              maxHeight: "40vh",
              aspectRatio: 1,
            }}
            responsive
          >
            <Pie
              data={data || []}
              labelLine={false}
              label={renderCustomizedLabel}
              fill="#8884d8"
              dataKey="count"
              nameKey="status"
              isAnimationActive={isAnimationActive}
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${entry.status}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
          </PieChart>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              marginTop: "20px",
              gap: "15px",
            }}
          >
            {data.map((entry, index) => (
              <div
                key={entry.method}
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <div
                  style={{
                    width: "15px",
                    height: "15px",
                    backgroundColor: COLORS[index % COLORS.length],
                  }}
                ></div>
                <span>
                  {entry.status} ({entry.count})
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
);

export default OrderDistributionPieChart;
